import { IonInput, IonItem, IonLabel } from '@ionic/react';
import React, { useEffect, useRef } from 'react';

import useMask, { MaskType } from '../../../hooks/Utils/useMask';
import FormItem from '../FormItem';

interface MaskedFormFieldProps {
  name: string;
  label: string;
  placeholder: string;
  maxLength?: number;
  control: any;
  errors: any;
  rules: any;
  maskType?: MaskType;
  transform?: (value: string) => string;
  withIcon?: boolean;
  opcionSeleccionada: string;
  cardType?: string;
  getCardIcon?: () => React.ReactNode;
}

const MaskedFormField: React.FC<MaskedFormFieldProps> = ({
  name,
  label,
  placeholder,
  maxLength,
  control,
  errors,
  rules,
  transform,
  maskType = 'none',
  withIcon,
  opcionSeleccionada,
  getCardIcon,
}) => {
  const maskRef = useMask(maskType);
  const ionInputRef = useRef<HTMLIonInputElement>(null);

  useEffect(() => {
    const applyMask = async () => {
      if (ionInputRef.current && maskType !== 'none') {
        const nativeInput = await ionInputRef.current.getInputElement();
        if (nativeInput && maskRef) {
          maskRef(nativeInput);
        }
      }
    };
    applyMask();
  }, [maskRef, maskType]);

  return (
    <FormItem
      name={name}
      control={control}
      errors={errors}
      rules={rules}
      render={({ value, onChange: rhfOnChange }) => (
        <IonItem>
          <IonLabel position="floating">{label}</IonLabel>
          <IonInput
            ref={ionInputRef}
            disabled={!opcionSeleccionada}
            value={value}
            inputMode="tel"
            onIonChange={(e) => rhfOnChange(e.detail.value || '')}
            onIonBlur={() => {
              if (transform && value) {
                rhfOnChange(transform(value));
              }
            }}
            placeholder={placeholder}
            maxlength={maxLength}
          >
            {withIcon && getCardIcon && getCardIcon()}
          </IonInput>
        </IonItem>
      )}
    />
  );
};

export default MaskedFormField;
